export default "__VITE_ASSET__C4vT3AS8__"